import React from 'react';
import { Button, Spacer, ContentBoxContainer, ContentBoxText, ContentBoxFigure, PenlySeo } from 'components';
import { Routes } from 'utils/routes';
// import ReactMarkdown from 'react-markdown';
// import SERVICS_PAGE_QUERY from 'queries/pages/services';

export default function Vaerktoejer() {
    const title = 'Penly - Tag kontrol over din privatøkonomi';
    const description = 'Penly giver dig digitale værktøjer til at planlægge din privatøkonomi langsigtet og agere på kort sigt, når behovet og mulighederne opstår.';
    const image = { url: '/static/gfx/content/penly-content-2.jpg' };

    return (
        <>
            { /* <Query query={ SERVICS_PAGE_QUERY }>
                { ({
                    data: {
                        servicesPage: { content, services },
                    },
                }) => {
                    return (
                        <>
                            <PageContent { ...content } />
                            <Spacer />
                            <div>
                                { services.map(service => (
                                    <div key={ service.id }>
                                        <h4>{ service.title }</h4>
                                        <ReactMarkdown source={ service.text } />
                                    </div>
                                )) }
                            </div>
                        </>
                    );
                } }
            </Query> */ }

            <PenlySeo title={ title } description={ description } image={ image } />
            <ContentBoxContainer className="fluid">
                <ContentBoxText>
                    <h1 className="nomb">Vi giver dig viden om <span className="color-highlight">din økonomi</span></h1>
                    <p>
                        Med Penly får du adgang til værktøjer, som gør dig i stand
                        til at se, hvor der er mulige forbedringer. Vi ruster dig til at
                        indgå i en dialog med din bank eller pensionsselskab.
                    </p>
                </ContentBoxText>
                <ContentBoxFigure className="penlylogoSymbolTeal"></ContentBoxFigure>
            </ContentBoxContainer>

            <ContentBoxContainer>
                <ContentBoxFigure figure="/static/gfx/content/penly-content-2.jpg" className="brbr brtl servicelogoinline">
                    <img src="/static/gfx/PenlyPensionsTjekLogo.svg" alt="Penly PensionsTjek" />
                </ContentBoxFigure>
                <ContentBoxText>
                    <h3>Penly PensionsTjek</h3>
                    <p>
                        Med Penlys digitale PensionsTjek får du en objektiv analyse af din pensionsopsparing.
                    </p>
                    <p>
                        Du får bud på, hvordan du kan forbedre og optimere din opsparing, så den er større, den dag du går på pension.
                        Eksempelvis analyserer vi om nogle ordninger med fordel kan samles, så du undgår at betale for meget i administrationsomkostninger.
                    </p>
                    <Spacer />
                    <div className="center">
                        <Button href={ Routes.PensionCheck.LandingPage }>Læs mere om PensionsTjek</Button>
                    </div>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer size="large" />

            <ContentBoxContainer>
                <ContentBoxFigure figure="/static/gfx/PenlyLogoSymbol.svg" className="single"></ContentBoxFigure>
            </ContentBoxContainer>


            <Spacer size="large" />

            <ContentBoxContainer className="mobileflip">
                <ContentBoxText>
                    <h3>Penly InvestTjek</h3>
                    <p>
                        Penly InvestTjek er til dig der har penge i indeksfonde f.eks. investeringsforeninger og ETF’er.
                    </p>
                    <p>
                        Få svar på hvordan din investering klarer sig sammenlignet med andre, hvor risikoniveauet og sammensætningen af aktier og obligationer
                        er den samme som i din portefølje. Du kan nemt følge dine investeringer, så du kan handle, hvis de ikke udvikler sig optimalt.
                    </p>
                    <Spacer />
                    <div className="center">
                        <Button href={ Routes.InvestCheck.LandingPage }>Læs mere om InvestTjek</Button>
                    </div>
                </ContentBoxText>
                <ContentBoxFigure figure="/static/gfx/content/penly-content-3.jpg" className="brtr brbl servicelogoinline">
                    <img src="/static/gfx/PenlyInvestTjekLogo.svg" alt="Penly InvestTjek" />
                </ContentBoxFigure>
            </ContentBoxContainer>

            <Spacer size="large" />

            <ContentBoxContainer>
                <ContentBoxFigure figure="/static/gfx/PenlyLogoSymbol.svg" className="single"></ContentBoxFigure>
            </ContentBoxContainer>

            <Spacer size="large" />
            <ContentBoxContainer>
                <ContentBoxFigure figure="/static/gfx/content/penly-content-26.jpg" className="brbr brtl servicelogoinline">
                    <img src="/static/gfx/PenlyPlayLogoWhiteSecondary.svg" alt="Penly Play" />
                </ContentBoxFigure>
                <ContentBoxText>
                    <h3>Penly Play</h3>
                    <p>
                        Vil du selv bestemme hvornår du skal på pension?
                    </p>
                    <p>
                        Se, hvordan dine valg i dag påvirker din pension. Indtast nogle få oplysninger, og find ud af, hvad der skal til for at få den fremtid, du drømmer om.                    </p>
                    <p>Penly Play kræver ikke profiloprettelse eller adgang til dine finansielle data.</p>
                    <Spacer />
                    <div className="center">
                        <Button href={ Routes.PenlyPlay.LandingPage }>Prøv Penly Play</Button>
                    </div>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer size="large" />

            <ContentBoxContainer>
                <ContentBoxFigure figure="/static/gfx/PenlyLogoSymbol.svg" className="single"></ContentBoxFigure>
            </ContentBoxContainer>


            <Spacer size="large" />
            <ContentBoxContainer>
                <ContentBoxText className="background-primary brtl">
                    <h3>Få en sund rutine uden at få sved på panden</h3>
                    <p>
                        Vi vil gøre det nemt at skabe overblik over din privatøkonomi, så du kan
                        tage ejerskab over din egen økonomi, og dermed få mest muligt ud af dine
                        penge. Det, tror vi, giver dig den største grad af frihed.
                    </p>
                    <Spacer />
                    <div className="center">
                        <Button href={ Routes.AboutPenly } color="white">Læs mere om Penly</Button>
                    </div>
                </ContentBoxText>
                <ContentBoxFigure className="background-highlight brbr penlylogowhite" figure="/static/gfx/PenlyLogoWhite.svg"></ContentBoxFigure>
            </ContentBoxContainer>

            <Spacer size="large" />
        </>
    );
}
